import {saveLG} from "../../services/lg.js";
import qs from "qs";
export default {
    data(){
        return {
            LGStatus: false,
            pdfShow:false,
            title:'报告页-测评获客版'
        }
    },
    created(){
        let query = qs.parse(location.search.slice(1));
        if(query.tmrId){
          this.title = '报告页-企业微信版客户端'
        }   
        this.getLGStatus();
        this.sendLG(1)
    },
    methods:{
        getLGStatus() {
            this.$http({
              loading: true,
              url: "/bdzb-core-service/lg/getOrderOffline",
              data: {
                method:this.method2,
                // code:this.code
              },
              method: "POST",
            }).then((data) => {
              this.LGStatus = data.flag == "1" ? true : false;
            });
        },
        sendLG(type) {
            let method = this['method' + type];
            if(type == 2 && this.LGStatus){
                return;
            }
            saveLG({
                method,
                productName:this.productName
            }).then(()=>{
                type == 2 && (this.LGStatus = true);
            })
        },
        pdfPreview(e){
            let userAgent = window.navigator.userAgent;
            if(userAgent.indexOf(' Android ') > -1){
                e.preventDefault();
                let baseUrl = location.origin + '/wmpages/pdfjs/web/viewer.html?url=';
                let pdfUrl = e.target.href;
                window.open(baseUrl + pdfUrl);
            }
        },
    }
}